function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo, useCallback } from "react";
import { Range as ReactRange, getTrackBackground } from "react-range";
import styled, { css } from "styled-components";
import { dividerColor, primaryColor } from "../../../helpers/color";
import transition from "../../../helpers/transition";
import { transparentizedPrimaryColor } from "../../../helpers/transparentize";
import Label from "../../Data/Label";
const Track = /*#__PURE__*/styled.div.attrs(({
  min,
  max,
  values,
  direction,
  ...props
}) => ({
  style: {
    backgroundImage: getTrackBackground({
      values,
      min,
      max,
      direction,
      colors: [primaryColor(props), "transparent"]
    })
  }
})).withConfig({
  displayName: "Track",
  componentId: "sc-1p0c09f-0"
})(["border-radius:3px;background-color:", ";", ""], dividerColor, ({
  direction
}) => direction === "to top" ? css(["width:6px;min-height:120px;margin:15px 0;"]) : css(["height:6px;width:100%;min-width:120px;"]));
const Thumb = /*#__PURE__*/styled.div.withConfig({
  displayName: "Thumb",
  componentId: "sc-1p0c09f-1"
})(["", " width:16px;height:16px;border-radius:100%;background-color:", ";outline:none;&:hover{box-shadow:0 0 0 6px ", ";}"], transition(["box-shadow"]), primaryColor, transparentizedPrimaryColor);
const Range = /*#__PURE__*/memo(({
  min,
  max,
  value,
  label,
  direction,
  onChange,
  ...props
}) => {
  const values = [value];
  const options = {
    min,
    max,
    values,
    direction
  };
  const onChangeHandler = useCallback(([value]) => onChange(value), [onChange]);
  return /*#__PURE__*/React.createElement(ReactRange, _extends({}, props, options, {
    onChange: onChangeHandler,
    renderTrack: ({
      props,
      children
    }) => /*#__PURE__*/React.createElement(Track, _extends({}, props, options), children),
    renderThumb: ({
      props
    }) => /*#__PURE__*/React.createElement(Thumb, props)
  }));
});
Range.Label = styled(Label).withConfig({
  displayName: "Label",
  componentId: "sc-1p0c09f-2"
})(["margin-left:15px;width:50px;"]);
export default Range;
//# sourceMappingURL=index.js.map